/* ============================================================================
   OPTICALH · Mega Menu — Behavior & DOM enhancements
   ============================================================================
   v7.0 · Refactor 2026-06-18

   PURPOSE
   ───────
   This script complements opticalh-megamenu.css with runtime DOM logic that
   pure CSS cannot do:

     · Strip redundant brand prefixes/suffixes in the Marcas megamenu
       e.g. "Gafas de Sol Ray-Ban" → "Ray-Ban" (under the "Gafas de Sol" heading)
     · Add the .opticalh-ver-todas class to "Ver todas" / "View all" links
     · Style gender items + insert mobile separators
     · A11y + perf: aria-haspopup, lazy + async decoding for images
     · Robust hover handling: 250ms grace period, hover-bridge zone, no
       premature close when crossing the trigger→panel gap
     · Subtle dock-style hover on promo items (3% scale max)

   STRUCTURE
   ─────────
     §1  i18n helpers (cyrillic/latin detection, "ver todas" prefixes)
     §2  Brand prefix stripping (Marcas megamenu)
     §3  Style "Ver todas" links + mobile menu styling
     §4  Accessibility + image perf
     §5  Subtle dock hover effect on promo items
     §6  Run-all + MutationObserver to keep DOM in sync
     §7  Robust megamenu hover (open/close with grace period)
   ============================================================================ */

(function () {
  'use strict';

  /* ==========================================================================
     §1 · i18n helpers
     ========================================================================== */

  /* "Ver todas / View all" prefixes across languages (used to identify
     CTA links inside link lists). */
  var VER_TODAS_PREFIXES = [
    'ver toda', 'ver todos',
    'view all', 'see all', 'show all',
    'voir tout', 'voir toute',
    'alle anzeigen', 'alle ansehen',
    'смотреть все',
    'посмотреть все'
  ];

  /* Gender words (used in mobile menu styling). */
  var GENDER_WORDS = {
    'hombre': 1, 'mujer': 1, 'niños': 1,
    'men': 1, 'women': 1, 'kids': 1, 'children': 1,
    'homme': 1, 'femme': 1, 'enfants': 1,
    'herren': 1, 'damen': 1, 'kinder': 1,
    'мужские': 1,
    'женские': 1,
    'детские': 1,
    'мужчины': 1,
    'женщины': 1,
    'дети': 1
  };

  function isVerTodasLink(text) {
    var lower = text.toLowerCase().trim();
    for (var i = 0; i < VER_TODAS_PREFIXES.length; i++) {
      if (lower.indexOf(VER_TODAS_PREFIXES[i]) === 0) return true;
    }
    return false;
  }
  function isGenderItem(text) { return GENDER_WORDS[text.toLowerCase().trim()] === 1; }
  function hasCyrillic(text)  { return /[Ѐ-ӿ]/.test(text); }
  function hasLatin(text)     { return /[a-zA-ZÀ-ɏ]/.test(text); }

  /* Pulls just the latin words from a mixed Cyrillic + Latin string,
     used to surface the brand name (always written in Latin script). */
  function extractLatinPart(text) {
    var latin = text.split(/\s+/).filter(function (w) {
      return hasLatin(w) && !hasCyrillic(w);
    });
    return latin.length ? latin.join(' ') : null;
  }


  /* ==========================================================================
     §2 · Brand prefix stripping (Marcas megamenu)
     The shop's link titles often include the category as prefix or suffix
     e.g. "Gafas de Sol Ray-Ban" / "Ray-Ban Gafas de Sol" / "Sonnenbrillen Ray-Ban".
     This is verbose under a section header that already says "Gafas de Sol".
     Strip the redundant part.
     ========================================================================== */
  function stripBrandPrefixes() {
    var marcasMega = document.querySelector('#header-menu-dropdown-7');
    if (!marcasMega) return;

    marcasMega.querySelectorAll('.v-stack.gap-4').forEach(function (section) {
      var heading = section.querySelector('.subheading');
      if (!heading) return;

      var headingText = heading.textContent.trim();

      /* Heading variants for matching — handle German plurals like
         "Sonnenbrillen" (heading) vs "Sonnenbrille" (in link text). */
      var variants = [headingText];
      if (headingText.endsWith('en') && headingText.length > 5) variants.push(headingText.slice(0, -2));
      else if (headingText.endsWith('n') && headingText.length > 4) variants.push(headingText.slice(0, -1));

      section.querySelectorAll('.mega-menu__linklist a.link-reversed').forEach(function (link) {
        var text = link.textContent.trim();
        if (isVerTodasLink(text)) return;

        var stripped = false;
        for (var v = 0; v < variants.length && !stripped; v++) {
          var variant = variants[v];
          if (text.startsWith(variant + ' ')) {
            link.textContent = text.substring(variant.length + 1);
            stripped = true;
          } else if (text.endsWith(' ' + variant)) {
            link.textContent = text.substring(0, text.length - variant.length - 1);
            stripped = true;
          }
        }

        /* Russian fallback: if text mixes Cyrillic + Latin, surface just
           the Latin (brand) name. */
        if (!stripped && hasCyrillic(text) && hasLatin(text)) {
          var brand = extractLatinPart(text);
          if (brand && brand.length >= 3) link.textContent = brand;
        }
      });
    });
  }


  /* ==========================================================================
     §3 · "Ver todas" link styling + mobile menu styling
     ========================================================================== */
  function styleVerTodasDesktop() {
    document.querySelectorAll('.mega-menu__linklist a').forEach(function (link) {
      if (isVerTodasLink(link.textContent.trim()) &&
          !link.classList.contains('opticalh-ver-todas')) {
        link.classList.add('opticalh-ver-todas');
      }
    });
  }

  function styleMobileMenu() {
    var panels = document.querySelectorAll(
      '.menu-drawer__panel ul, .panel__content ul, .drawer-menu ul'
    );

    panels.forEach(function (ul) {
      var items = ul.querySelectorAll(':scope > li');
      var lastSpecialIdx = -1;
      var alreadyHasSeparator = ul.querySelector('.opticalh-mobile-separator');

      items.forEach(function (li, idx) {
        var link = li.querySelector('a, button');
        if (!link) return;

        var text = link.textContent.trim();
        if (isGenderItem(text)) {
          if (!link.classList.contains('opticalh-gender-item')) {
            link.classList.add('opticalh-gender-item');
          }
          lastSpecialIdx = idx;
        } else if (isVerTodasLink(text)) {
          if (!link.classList.contains('opticalh-ver-todas-mobile')) {
            link.classList.add('opticalh-ver-todas-mobile');
          }
          lastSpecialIdx = idx;
        }
      });

      /* Insert visual separator after last gender/ver-todas item */
      if (lastSpecialIdx >= 0 && !alreadyHasSeparator && lastSpecialIdx < items.length - 1) {
        var sep = document.createElement('li');
        sep.className = 'opticalh-mobile-separator';
        sep.setAttribute('aria-hidden', 'true');
        items[lastSpecialIdx].parentNode.insertBefore(sep, items[lastSpecialIdx].nextSibling);
      }
    });
  }


  /* ==========================================================================
     §3b · Localization selector pills
     Shorten the verbose labels of the country/currency and language buttons
     to compact 2-3 char codes (ES, EUR, EN…). This lets us style them as
     pills that read at a glance instead of just a flag + chevron.

     Mapping rule:
       · "España (EUR €)"  → "EUR €"   (keeps currency, drops country word)
       · "Español"         → "ES"
       · "English"         → "EN"
       · "Français"        → "FR"
       · "Deutsch"         → "DE"
       · "Русский"         → "RU"
       · Any 5+ char       → first 2 chars uppercased (fallback)

     Original full text is kept in `data-mm-original` so the dropdown that
     opens still has access to it if needed.
     ========================================================================== */
  var LANG_CODES = {
    'español': 'ES', 'spanish':  'ES', 'castellano': 'ES',
    'english': 'EN', 'inglés':   'EN',
    'français': 'FR', 'french':  'FR', 'francés':   'FR',
    'deutsch': 'DE', 'german':   'DE', 'alemán':    'DE',
    'русский': 'RU', 'russian':  'RU', 'ruso':      'RU',
    'italiano': 'IT', 'italian': 'IT',
    'português': 'PT', 'portuguese': 'PT'
  };

  function shortenLocalizationLabels() {
    var secNav = document.querySelector('.header__secondary-nav');
    if (!secNav) return;

    secNav.querySelectorAll('button[aria-haspopup] .subheading, a.localization-selector .subheading')
      .forEach(function (span) {
        /* Only run once per element */
        if (span.hasAttribute('data-mm-original')) return;

        var original = span.textContent.trim();
        if (!original) return;
        span.setAttribute('data-mm-original', original);

        var lower = original.toLowerCase();
        var shortened;

        /* Pattern: "Country (XXX €)" or "Country (XXX $)" → take currency */
        var currencyMatch = original.match(/\(([A-Z]{3})\s*([^)]+)?\)/);
        if (currencyMatch) {
          shortened = currencyMatch[1];   /* e.g. "EUR" */
        } else if (LANG_CODES[lower]) {
          shortened = LANG_CODES[lower];
        } else {
          /* Fallback: first 2 chars uppercase */
          shortened = original.substring(0, 2).toUpperCase();
        }

        span.textContent = shortened;
      });
  }


  /* ==========================================================================
     §3c · Nav cluster separators
     Inserta puntos `•` entre clusters lógicos del top-nav para que los
     13 items sean escaneables como 4 grupos:
       [Sol · Graduadas · Deportivas] • [Hombre · Mujer · Niños]
       • [Marcas · Cristales · Smart · Lentillas · Accesorios] • [Blog · Ayuda]
     Los textos se detectan por contenido para que funcione en todos los
     idiomas que tradujimos (ES/EN/FR/DE/RU).
     ========================================================================== */
  var CLUSTER_BOUNDARIES = {
    /* Items DESPUÉS de los cuales insertamos un separador */
    es: ['Gafas Deportivas', 'Niños', 'Accesorios'],
    en: ['Sports Glasses', 'Kids', 'Accessories'],
    fr: ['Lunettes de sport', 'Enfants', 'Accessoires'],
    de: ['Sportbrillen', 'Kinder', 'Zubehör'],
    ru: ['Спортивные очки', 'Дети', 'Аксессуары']
  };

  function insertNavClusterSeparators() {
    /* v8.1 — separadores eliminados: el nav tiene 13 items y a vw<1920 cada
       elemento que añadimos provoca overlap con el secondary-nav. Si en el
       futuro queremos clusters visuales, mejor con un `margin-left` mayor en
       los items frontera (sin elemento físico que ocupe espacio). */
    var ul = document.querySelector('.header__primary-nav > ul');
    if (!ul) return;
    ul.querySelectorAll(':scope > .nav-cluster-sep').forEach(function (s) { s.remove(); });
  }


  /* ==========================================================================
     §3d · Cart count badge
     Lee el contador de items del carrito desde la API Shopify (/cart.js) y
     pinta un badge encima del icono del carrito si hay items.
     Se actualiza al añadir/quitar items (escucha el evento cart:updated).
     ========================================================================== */
  function updateCartBadge() {
    var cartLink = document.querySelector('.header__secondary-nav a[href*="cart"]');
    if (!cartLink) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = cartLink.querySelector('.oh-cart-badge');
        var count = cart.item_count || 0;
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'oh-cart-badge';
            badge.setAttribute('aria-label', 'items en el carrito');
            cartLink.appendChild(badge);
          }
          badge.textContent = count > 99 ? '99+' : String(count);
        } else if (badge) {
          badge.remove();
        }
      })
      .catch(function () { /* sin red o cart inexistente, ignorar silenciosamente */ });
  }


  /* ==========================================================================
     §4 · Accessibility + image performance
     ========================================================================== */
  function enhanceA11yPerf() {
    /* aria-haspopup for any trigger with submenu */
    document.querySelectorAll('[data-open-on-hover][aria-controls]').forEach(function (t) {
      if (!t.hasAttribute('aria-haspopup')) t.setAttribute('aria-haspopup', 'menu');
    });
    /* Lazy-load images inside menus (Core Web Vitals) */
    document.querySelectorAll('header-mega-menu img, header-dropdown-menu img, .menu-promo img')
      .forEach(function (img) {
        if (!img.getAttribute('loading'))  img.setAttribute('loading', 'lazy');
        if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
      });
  }


  /* ==========================================================================
     §5 · Subtle dock hover effect
     Tiny scale (max 3%) only when the cursor is directly over a promo item.
     Skipped on touch devices and when reduced-motion is preferred.
     ========================================================================== */
  function setupPromoDock() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;

    var RADIUS    = 80;    /* px around item center where effect ramps up */
    var MAX_SCALE = 0.03;  /* 3% maximum scale at center */
    var THRESHOLD = 0.3;   /* min intensity to activate (avoids "magnet") */

    document.querySelectorAll('header-mega-menu .menu-promo').forEach(function (row) {
      if (row.__ohDock) return;       /* don't bind twice */
      row.__ohDock = true;

      row.addEventListener('pointermove', function (e) {
        row.querySelectorAll('.menu-promo__item').forEach(function (el) {
          var r  = el.getBoundingClientRect();
          var dx = Math.abs(e.clientX - (r.left + r.width  / 2));
          var dy = Math.abs(e.clientY - (r.top  + r.height / 2));
          var d  = Math.max(dx, dy);
          var t  = Math.max(0, 1 - d / RADIUS);

          el.style.transform = (t > THRESHOLD)
            ? 'scale(' + (1 + t * MAX_SCALE) + ')'
            : '';
        });
      });

      row.addEventListener('pointerleave', function () {
        row.querySelectorAll('.menu-promo__item').forEach(function (el) {
          el.style.transform = '';
        });
      });
    });
  }


  /* OH_DESKTOP_MENU_VISUAL_OWNER_V3
     Make cross-menu ownership visual in the same frame. Native hide still
     owns ARIA and lifecycle. If an old hide settles after a rapid reopen, its
     after-hide display:none is removed before the browser can paint. */
  var SUPERSEDED_MENU_ATTR = 'data-oh-menu-superseded';
  var DESKTOP_MENU_SELECTOR = 'header-mega-menu, header-dropdown-menu';
  var OPEN_DESKTOP_MENU_SELECTOR =
    'header-mega-menu[open], header-dropdown-menu[open]';
  var DESKTOP_MENU_TRIGGER_SELECTOR =
    '.header__primary-nav [data-open-on-hover][aria-controls]';

  function restoreReopenedDesktopMenu(panel) {
    panel.removeAttribute(SUPERSEDED_MENU_ATTR);
    if (panel.hasAttribute('open')) {
      panel.style.removeProperty('display');
    }
  }

  function closeOtherDesktopMenus(currentPanel) {
    if (!desktopMenuMedia || !desktopMenuMedia.matches) return;

    document.querySelectorAll(OPEN_DESKTOP_MENU_SELECTOR).forEach(function (panel) {
      if (panel === currentPanel) return;

      panel.setAttribute(SUPERSEDED_MENU_ATTR, '');
      try {
        var outgoingTrap = panel.focusTrap;
        if (outgoingTrap && typeof outgoingTrap.deactivate === 'function') {
          outgoingTrap.deactivate({ returnFocus: false });
        }
      } catch (error) {
        /* Native hide below remains the semantic state authority. */
      }

      if (typeof panel.hide === 'function') {
        var completion = panel.hide();
        if (completion && typeof completion.catch === 'function') {
          completion.catch(function () {});
        }
      }
    });
  }

  function desktopMenuForTrigger(trigger) {
    var panelId = trigger && trigger.getAttribute('aria-controls');
    var panel = panelId && document.getElementById(panelId);
    return panel && panel.matches(DESKTOP_MENU_SELECTOR) ? panel : null;
  }

  function desktopTriggerForMenu(panel) {
    var controls = panel && panel.controls ? panel.controls : [];
    for (var i = 0; i < controls.length; i++) {
      if (controls[i].matches(DESKTOP_MENU_TRIGGER_SELECTOR)) return controls[i];
    }
    return null;
  }

  function focusDesktopMenuTrigger(trigger) {
    if (!trigger || !trigger.isConnected || !desktopMenuMedia.matches) return;
    try {
      trigger.focus({ preventScroll: true });
    } catch (error) {
      trigger.focus();
    }
  }

  function closeActiveDesktopMenu(panel, trigger) {
    panel.removeAttribute(SUPERSEDED_MENU_ATTR);
    try {
      var activeTrap = panel.focusTrap;
      if (activeTrap && typeof activeTrap.deactivate === 'function') {
        activeTrap.deactivate({ returnFocus: false });
      }
    } catch (error) {
      /* Explicit focus restoration below remains authoritative. */
    }

    var completion = typeof panel.hide === 'function'
      ? panel.hide()
      : Promise.resolve();
    Promise.resolve(completion).catch(function () {}).then(function () {
      if (!panel.hasAttribute('open') &&
          !document.querySelector(OPEN_DESKTOP_MENU_SELECTOR)) {
        focusDesktopMenuTrigger(trigger);
      }
    });
  }

  function activeDesktopMenu() {
    return document.querySelector(
      'header-mega-menu[open]:not([' + SUPERSEDED_MENU_ATTR + ']), ' +
      'header-dropdown-menu[open]:not([' + SUPERSEDED_MENU_ATTR + '])'
    ) || document.querySelector(OPEN_DESKTOP_MENU_SELECTOR);
  }

  function setupDesktopMenuDismissal() {
    if (document.__ohDesktopMenuDismissV3Bound) return;
    document.__ohDesktopMenuDismissV3Bound = true;

    document.addEventListener('keydown', function (event) {
      if (!desktopMenuMedia.matches ||
          (event.key !== 'Escape' && event.key !== 'Esc')) return;
      var panel = activeDesktopMenu();
      if (!panel) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      closeOtherDesktopMenus(panel);
      closeActiveDesktopMenu(panel, desktopTriggerForMenu(panel));
    }, true);

    document.addEventListener('click', function (event) {
      if (!desktopMenuMedia.matches || !event.target.closest) return;
      var trigger = event.target.closest(DESKTOP_MENU_TRIGGER_SELECTOR);
      var panel = desktopMenuForTrigger(trigger);
      if (!panel || !panel.hasAttribute('open')) return;

      /* OH_DESKTOP_MENU_LINK_NAVIGATION_V4
         Hover opens wide menus before click. If the active trigger is a real
         anchor and the label itself was activated, preserve the native
         navigation. The chevron and non-anchor controls keep native toggle
         semantics, while Escape remains the deterministic close action. */
      var triggerHref = trigger.getAttribute('href');
      if (trigger.tagName === 'A' && event.target === trigger &&
          triggerHref && !/^javascript:/i.test(triggerHref)) return;

      event.preventDefault();
      event.stopPropagation();
      closeOtherDesktopMenus(panel);
      closeActiveDesktopMenu(panel, trigger);
    }, true);
  }

  function setupExclusiveDesktopMenus() {
    setupDesktopMenuDismissal();
    document.querySelectorAll(DESKTOP_MENU_SELECTOR).forEach(function (panel) {
      if (panel.__ohExclusiveMenuV3Bound) return;
      panel.__ohExclusiveMenuV3Bound = true;
      panel.addEventListener('dialog:before-show', function () {
        panel.removeAttribute(SUPERSEDED_MENU_ATTR);
        closeOtherDesktopMenus(panel);
      });
      panel.addEventListener('dialog:after-hide', function () {
        restoreReopenedDesktopMenu(panel);
      });
    });
  }


  /* ==========================================================================
     §6 · Run-all orchestrator
     Runs once at startup and again only after an explicit Shopify section
     reload. Menu state attributes are intentionally not observed.
     ========================================================================== */
  function runAll() {
    stripBrandPrefixes();
    styleVerTodasDesktop();
    styleMobileMenu();
    shortenLocalizationLabels();
    insertNavClusterSeparators();
    enhanceA11yPerf();
    setupPromoDock();
    setupExclusiveDesktopMenus();
  }

  /* Cart badge: actualizar al inicio + después de cualquier
     interacción que pueda haber modificado el carrito. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartBadge);
  } else {
    updateCartBadge();
  }
  document.addEventListener('cart:updated', updateCartBadge);
  document.addEventListener('cart:refresh',  updateCartBadge);
  /* Theme event: muchos themes lo emiten al cerrar el drawer */
  document.addEventListener('on:cart:after-update', updateCartBadge);

  /* Initial run */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  /* ==========================================================================
     §6b · Desktop/compact state synchronization
     DialogElement in theme.js is the sole owner of hover, open state,
     animations and focus trapping. This block only closes stale desktop
     surfaces when that interaction mode disappears.
     ========================================================================== */
  var desktopMenuMedia = window.matchMedia(
    '(min-width: 1820px) and (hover: hover) and (pointer: fine)'
  );

  function focusVisibleCompactMenuTrigger() {
    var triggers = document.querySelectorAll(
      'x-header.header .header__primary-nav > button[aria-controls="menu-drawer"]'
    );
    for (var i = 0; i < triggers.length; i++) {
      if (!triggers[i].getClientRects().length) continue;
      try {
        triggers[i].focus({ preventScroll: true });
      } catch (error) {
        triggers[i].focus();
      }
      return;
    }
  }

  function closeDesktopMenusForLayoutChange() {
    var active = document.activeElement;
    var focusWasInDesktopMenu = !!(
      active && active.closest && active.closest(
        '.header__primary-nav > ul, header-mega-menu, header-dropdown-menu'
      )
    );
    var hadOpenPanel = false;
    var completions = [];

    document.querySelectorAll(
      '.header__primary-nav [data-open-on-hover][aria-controls]'
    ).forEach(function (trigger) {
      var id = trigger.getAttribute('aria-controls');
      var panel = id && document.getElementById(id);
      if (panel && panel.hasAttribute('open')) {
        hadOpenPanel = true;
        if (typeof panel.hide === 'function') {
          completions.push(Promise.resolve(panel.hide()));
        }
      } else {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    var focusMustMove = !desktopMenuMedia.matches && (
      focusWasInDesktopMenu || hadOpenPanel
    );
    if (focusMustMove) {
      /* CSS can drop focus to body before the media-query event is delivered.
         The open-panel flag preserves that intent. A synchronous attempt plus
         one zero-delay retry does not depend on a hidden leave animation. */
      focusVisibleCompactMenuTrigger();
      window.setTimeout(focusVisibleCompactMenuTrigger, 0);
      Promise.allSettled(completions).then(focusVisibleCompactMenuTrigger);
    }
  }

  if (desktopMenuMedia.addEventListener) {
    desktopMenuMedia.addEventListener('change', closeDesktopMenusForLayoutChange);
  } else {
    desktopMenuMedia.addListener(closeDesktopMenusForLayoutChange);
  }
  window.addEventListener('pageshow', closeDesktopMenusForLayoutChange);
  document.addEventListener('shopify:section:load', function () {
    runAll();
    closeDesktopMenusForLayoutChange();
  });
  if (!desktopMenuMedia.matches) closeDesktopMenusForLayoutChange();
})();
